import { useEffect, useState } from 'react';
import useAxios from '../../../../../Hooks/use-axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { winnreAuth } from '../../../../../utils/axios';

const useData = (paymentId) => {
    const [payment, setPayment] = useState('');
    const [showError, setShowError] = useState(false);
    const [deals, setDeals] = useState([]);

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const {
        isLoading: loadingOrder,
        error,
        sendRequest: fetchOrderDetails
    } = useAxios();

    const { isLoading: loadingDeals, sendRequest: fetchDeals } = useAxios();

    const fetchOrder = () => {
        console.log('forbidden');
        winnreAuth({
            method: 'get',
            url: `winnre/user/payment/get/${paymentId}`
        })
            .then((data) => {
                if (data.status === 'FAILED') {
                    setShowError(true);
                    //    toast.error(data.message);
                } else {
                    setShowError(false);
                }
                console.log('payment details', data);
                window?.webengage?.track('PaymentStatus', {
                    Status:
                        data?.paymentStatus === 'SUCCESS'
                            ? 'SUCCESS'
                            : 'FAILED',
                    paymentId: data?.id,
                    DealID: data?.dealId,
                    Amount: data?.amount,
                    TransactionID: data?.paymentReferenceNumber,
                    PaymentID: data?.id
                });
                setPayment(data);
            })
            .catch((error) => {
                console.log('error order', error);
                setShowError(true);
            });
    };

    useEffect(() => {
        getOffers();
    }, []);

    const getOffers = () => {
        fetchDeals(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&rewardsPage=true`,
                method: 'get',
                isFormData: true
            },
            (res) => {
                console.log('ordersPage Deals', res?.content);
                setDeals(res?.content);
            }
        );
    };

    useEffect(() => {
        fetchOrder();
    }, [paymentId, isAuthenticated]);

    useEffect(() => {
        getOffers();
    }, []);

    return {
        payment,
        loadingOrder,
        showError,
        isAuthenticated,
        deals
    };
};
export default useData;
